import { z } from 'zod'

export const FormCreatePriceListSchema = z.object({
  nome: z.string().min(1, 'Nome obrigatório'),
})

export type FormCreatePriceList = z.infer<typeof FormCreatePriceListSchema>

export const FormCreatePriceListWithStatusSchema = z.object({
  nome: z.string().min(1, 'Nome obrigatório'),
  situacao: z.string().min(1, 'Situação obrigatória'),
})

export type FormCreatePriceListWithStatus = z.infer<
  typeof FormCreatePriceListWithStatusSchema
>
